module.exports = __webpack_public_path__ + "img/title-bg.775c30e0.png";